import { CommonModule } from '@angular/common';
import { Component, computed, inject, input} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppHelp } from '../../../../models/app-help.model';
import { HelpService } from '../../../../services/help.service';
import { ShareComponent } from '../share/share.component';


@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    ShareComponent,
    TranslatePipe,
  ],
  providers: [
    HelpService,
  ]
})
export default class HelpComponent {
  public items$!: Observable<AppHelp[]>;
  public readonly expandedItem = computed(() => Number(this.item()));
  public readonly item = input<number>();

  private readonly appHelpService = inject(HelpService);

  constructor() {
    this.items$ = this.appHelpService.getAll();
  }

}
